let localStorage: any;
try {
    localStorage = require("local-storage");
} catch (e) {
    if(!localStorage) localStorage = {};
}
if(typeof localStorage.get !== "function") {
    localStorage.get = ():any => { return null; }
    localStorage.set = () => {};
    localStorage.removeItem = () => {};
    localStorage.remove = () => {};
}

export default localStorage;


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/utils/local-storage.ts